@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_842_359_930)
public val Res.string.roster_role: StringResource by lazy {
      StringResource("string:roster_role", "roster_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264697, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375505, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242568, 27),
      ))
    }

@delegate:ResourceContentHash(1_710_256_889)
public val Res.string.roster_role_optional: StringResource by lazy {
      StringResource("string:roster_role_optional", "roster_role_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264628, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375420, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242519, 48),
      ))
    }

@delegate:ResourceContentHash(1_403_320_157)
public val Res.string.roster_save_as_template: StringResource by lazy {
      StringResource("string:roster_save_as_template", "roster_save_as_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264733, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375541, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242596, 55),
      ))
    }

@delegate:ResourceContentHash(-862_656_510)
public val Res.string.roster_save_template: StringResource by lazy {
      StringResource("string:roster_save_template", "roster_save_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264793, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375621, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242652, 52),
      ))
    }

@delegate:ResourceContentHash(-935_548_855)
public val Res.string.roster_selected_count: StringResource by lazy {
      StringResource("string:roster_selected_count", "roster_selected_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264850, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375698, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242705, 49),
      ))
    }

@delegate:ResourceContentHash(-2_065_557_381)
public val Res.string.roster_selection_apply: StringResource by lazy {
      StringResource("string:roster_selection_apply", "roster_selection_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264904, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375756, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242755, 54),
      ))
    }

@delegate:ResourceContentHash(-1_130_659_486)
public val Res.string.roster_selection_clear: StringResource by lazy {
      StringResource("string:roster_selection_clear", "roster_selection_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 264959, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375831, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242810, 38),
      ))
    }

@delegate:ResourceContentHash(-898_939_544)
public val Res.string.roster_selection_no_templates: StringResource by lazy {
      StringResource("string:roster_selection_no_templates", "roster_selection_no_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265002, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375886, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242849, 69),
      ))
    }

@delegate:ResourceContentHash(-790_621_275)
public val Res.string.roster_shift_cost: StringResource by lazy {
      StringResource("string:roster_shift_cost", "roster_shift_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265068, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 375980, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242919, 53),
      ))
    }

@delegate:ResourceContentHash(-1_324_720_618)
public val Res.string.roster_shift_deleted: StringResource by lazy {
      StringResource("string:roster_shift_deleted", "roster_shift_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265126, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376062, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242973, 48),
      ))
    }

@delegate:ResourceContentHash(-1_261_798_716)
public val Res.string.roster_shift_details: StringResource by lazy {
      StringResource("string:roster_shift_details", "roster_shift_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265179, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376131, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243022, 48),
      ))
    }

@delegate:ResourceContentHash(-1_272_235_979)
public val Res.string.roster_shift_labour_warning: StringResource by lazy {
      StringResource("string:roster_shift_labour_warning", "roster_shift_labour_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265232, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376200, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243071, 63),
      ))
    }

@delegate:ResourceContentHash(850_799_373)
public val Res.string.roster_shift_no_rate: StringResource by lazy {
      StringResource("string:roster_shift_no_rate", "roster_shift_no_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265308, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376312, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243135, 44),
      ))
    }

@delegate:ResourceContentHash(-816_925_079)
public val Res.string.roster_shift_restored: StringResource by lazy {
      StringResource("string:roster_shift_restored", "roster_shift_restored", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265353, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376373, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243180, 49),
      ))
    }

@delegate:ResourceContentHash(507_650_011)
public val Res.string.roster_shift_unsupervised: StringResource by lazy {
      StringResource("string:roster_shift_unsupervised", "roster_shift_unsupervised", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265411, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376447, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243230, 81),
      ))
    }

@delegate:ResourceContentHash(469_897_281)
public val Res.string.roster_skeleton_empty_templates: StringResource by lazy {
      StringResource("string:roster_skeleton_empty_templates", "roster_skeleton_empty_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265485, 271),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376541, 395),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243312, 247),
      ))
    }

@delegate:ResourceContentHash(-1_520_952_022)
public val Res.string.roster_skeleton_failed: StringResource by lazy {
      StringResource("string:roster_skeleton_failed", "roster_skeleton_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265757, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 376937, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243560, 86),
      ))
    }

@delegate:ResourceContentHash(-639_659_390)
public val Res.string.roster_skeleton_no_week: StringResource by lazy {
      StringResource("string:roster_skeleton_no_week", "roster_skeleton_no_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 265856, 279),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 377064, 403),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243647, 263),
      ))
    }

@delegate:ResourceContentHash(1_855_428_099)
public val Res.string.roster_skeleton_open: StringResource by lazy {
      StringResource("string:roster_skeleton_open", "roster_skeleton_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266220, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 377580, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243987, 48),
      ))
    }

@delegate:ResourceContentHash(-234_241_988)
public val Res.string.roster_skeleton_open_finish: StringResource by lazy {
      StringResource("string:roster_skeleton_open_finish", "roster_skeleton_open_finish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266136, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 377468, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243911, 75),
      ))
    }

@delegate:ResourceContentHash(-318_788_591)
public val Res.string.roster_skeleton_prompt_missing_days: StringResource by lazy {
      StringResource("string:roster_skeleton_prompt_missing_days", "roster_skeleton_prompt_missing_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266273, 283),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 377649, 431),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244036, 263),
      ))
    }

@delegate:ResourceContentHash(-1_456_566_994)
public val Res.string.roster_skeleton_prompt_no_week: StringResource by lazy {
      StringResource("string:roster_skeleton_prompt_no_week", "roster_skeleton_prompt_no_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266557, 266),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378081, 414),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244300, 238),
      ))
    }

@delegate:ResourceContentHash(2_125_612_592)
public val Res.string.roster_skeleton_prompt_not_now: StringResource by lazy {
      StringResource("string:roster_skeleton_prompt_not_now", "roster_skeleton_prompt_not_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266824, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378496, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244539, 50),
      ))
    }

@delegate:ResourceContentHash(1_548_170_103)
public val Res.string.roster_skeleton_prompt_set_up: StringResource by lazy {
      StringResource("string:roster_skeleton_prompt_set_up", "roster_skeleton_prompt_set_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266875, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378555, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244590, 57),
      ))
    }

@delegate:ResourceContentHash(1_559_184_743)
public val Res.string.roster_skeleton_prompt_title: StringResource by lazy {
      StringResource("string:roster_skeleton_prompt_title", "roster_skeleton_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 266933, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378645, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244648, 60),
      ))
    }

@delegate:ResourceContentHash(1_502_798_753)
public val Res.string.roster_skeleton_title: StringResource by lazy {
      StringResource("string:roster_skeleton_title", "roster_skeleton_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267002, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378734, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244709, 65),
      ))
    }

@delegate:ResourceContentHash(-1_791_205_785)
public val Res.string.roster_skills: StringResource by lazy {
      StringResource("string:roster_skills", "roster_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267127, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378875, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244818, 29),
      ))
    }

@delegate:ResourceContentHash(-218_511_686)
public val Res.string.roster_skills_list: StringResource by lazy {
      StringResource("string:roster_skills_list", "roster_skills_list", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267072, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378820, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244775, 42),
      ))
    }

@delegate:ResourceContentHash(-594_762_539)
public val Res.string.roster_start_time: StringResource by lazy {
      StringResource("string:roster_start_time", "roster_start_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267169, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378917, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244848, 41),
      ))
    }

@delegate:ResourceContentHash(-1_835_375_532)
public val Res.string.roster_status_archived: StringResource by lazy {
      StringResource("string:roster_status_archived", "roster_status_archived", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267207, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 378971, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244890, 42),
      ))
    }

@delegate:ResourceContentHash(-662_619_893)
public val Res.string.roster_status_draft: StringResource by lazy {
      StringResource("string:roster_status_draft", "roster_status_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267258, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379026, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244933, 35),
      ))
    }

@delegate:ResourceContentHash(1_097_970_783)
public val Res.string.roster_status_locked: StringResource by lazy {
      StringResource("string:roster_status_locked", "roster_status_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267306, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379078, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244969, 36),
      ))
    }

@delegate:ResourceContentHash(1_643_144_261)
public val Res.string.roster_status_published: StringResource by lazy {
      StringResource("string:roster_status_published", "roster_status_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267351, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379131, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245006, 43),
      ))
    }

@delegate:ResourceContentHash(1_883_917_566)
public val Res.string.roster_status_skeleton: StringResource by lazy {
      StringResource("string:roster_status_skeleton", "roster_status_skeleton", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267459, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379275, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245114, 42),
      ))
    }

@delegate:ResourceContentHash(-285_031_587)
public val Res.string.roster_status_skeleton_hint: StringResource by lazy {
      StringResource("string:roster_status_skeleton_hint", "roster_status_skeleton_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267399, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379199, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245050, 63),
      ))
    }

@delegate:ResourceContentHash(522_401_442)
public val Res.string.roster_summary_filled: StringResource by lazy {
      StringResource("string:roster_summary_filled", "roster_summary_filled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267510, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379326, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245157, 49),
      ))
    }

@delegate:ResourceContentHash(1_281_999_016)
public val Res.string.roster_summary_open: StringResource by lazy {
      StringResource("string:roster_summary_open", "roster_summary_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267564, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379392, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245207, 43),
      ))
    }

@delegate:ResourceContentHash(-1_107_336_873)
public val Res.string.roster_summary_total_hours: StringResource by lazy {
      StringResource("string:roster_summary_total_hours", "roster_summary_total_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267608, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379452, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245251, 50),
      ))
    }

@delegate:ResourceContentHash(-817_981_919)
public val Res.string.roster_time_invalid: StringResource by lazy {
      StringResource("string:roster_time_invalid", "roster_time_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267663, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379519, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245302, 71),
      ))
    }

@delegate:ResourceContentHash(1_349_960_520)
public val Res.string.roster_to: StringResource by lazy {
      StringResource("string:roster_to", "roster_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267802, 21),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379702, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245417, 21),
      ))
    }

@delegate:ResourceContentHash(-275_387_384)
public val Res.string.roster_total_hours: StringResource by lazy {
      StringResource("string:roster_total_hours", "roster_total_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267759, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379643, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245374, 42),
      ))
    }

@delegate:ResourceContentHash(2_133_246_654)
public val Res.string.roster_unassign: StringResource by lazy {
      StringResource("string:roster_unassign", "roster_unassign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267947, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379899, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245554, 35),
      ))
    }

@delegate:ResourceContentHash(-2_006_937_529)
public val Res.string.roster_unassigned: StringResource by lazy {
      StringResource("string:roster_unassigned", "roster_unassigned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267885, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379801, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245496, 57),
      ))
    }

@delegate:ResourceContentHash(970_116_569)
public val Res.string.roster_unassigned_shifts: StringResource by lazy {
      StringResource("string:roster_unassigned_shifts", "roster_unassigned_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267824, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379728, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245439, 56),
      ))
    }

@delegate:ResourceContentHash(-1_049_684_314)
public val Res.string.roster_unfilled: StringResource by lazy {
      StringResource("string:roster_unfilled", "roster_unfilled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268049, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380021, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245640, 35),
      ))
    }

@delegate:ResourceContentHash(231_105_255)
public val Res.string.roster_unfilled_short: StringResource by lazy {
      StringResource("string:roster_unfilled_short", "roster_unfilled_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 267995, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 379959, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245590, 49),
      ))
    }

@delegate:ResourceContentHash(193_938_840)
public val Res.string.roster_unpublished_badge: StringResource by lazy {
      StringResource("string:roster_unpublished_badge", "roster_unpublished_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268089, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380069, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245676, 60),
      ))
    }

@delegate:ResourceContentHash(-1_854_025_699)
public val Res.string.roster_unpublished_hide: StringResource by lazy {
      StringResource("string:roster_unpublished_hide", "roster_unpublished_hide", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268154, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380154, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245737, 39),
      ))
    }

@delegate:ResourceContentHash(-320_601_698)
public val Res.string.roster_unpublished_removed: StringResource by lazy {
      StringResource("string:roster_unpublished_removed", "roster_unpublished_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268194, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380206, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245777, 54),
      ))
    }

@delegate:ResourceContentHash(645_708_256)
public val Res.string.roster_unpublished_shift: StringResource by lazy {
      StringResource("string:roster_unpublished_shift", "roster_unpublished_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268249, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380273, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245832, 64),
      ))
    }

@delegate:ResourceContentHash(-565_579_829)
public val Res.string.roster_unpublished_show: StringResource by lazy {
      StringResource("string:roster_unpublished_show", "roster_unpublished_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268310, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380354, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245897, 39),
      ))
    }

@delegate:ResourceContentHash(-917_944_825)
public val Res.string.roster_unpublished_title: StringResource by lazy {
      StringResource("string:roster_unpublished_title", "roster_unpublished_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268350, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380410, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245937, 96),
      ))
    }

@delegate:ResourceContentHash(-139_675_004)
public val Res.string.sales_import_action_closed: StringResource by lazy {
      StringResource("string:sales_import_action_closed", "sales_import_action_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268443, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380547, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246034, 58),
      ))
    }

@delegate:ResourceContentHash(1_461_940_979)
public val Res.string.sales_import_action_import: StringResource by lazy {
      StringResource("string:sales_import_action_import", "sales_import_action_import", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268518, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380638, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246093, 50),
      ))
    }

@delegate:ResourceContentHash(834_205_538)
public val Res.string.sales_import_action_manual: StringResource by lazy {
      StringResource("string:sales_import_action_manual", "sales_import_action_manual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268569, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380705, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246144, 62),
      ))
    }

@delegate:ResourceContentHash(-861_622_462)
public val Res.string.sales_import_action_replace: StringResource by lazy {
      StringResource("string:sales_import_action_replace", "sales_import_action_replace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268640, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380800, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246207, 71),
      ))
    }

@delegate:ResourceContentHash(397_072_421)
public val Res.string.sales_import_action_unchanged: StringResource by lazy {
      StringResource("string:sales_import_action_unchanged", "sales_import_action_unchanged", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268720, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380900, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246279, 61),
      ))
    }

@delegate:ResourceContentHash(152_437_327)
public val Res.string.sales_import_applied: StringResource by lazy {
      StringResource("string:sales_import_applied", "sales_import_applied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268778, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 380974, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246341, 76),
      ))
    }

@delegate:ResourceContentHash(469_960_334)
public val Res.string.sales_import_apply: StringResource by lazy {
      StringResource("string:sales_import_apply", "sales_import_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268851, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381099, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246418, 50),
      ))
    }

@delegate:ResourceContentHash(-250_072_873)
public val Res.string.sales_import_choose_file: StringResource by lazy {
      StringResource("string:sales_import_choose_file", "sales_import_choose_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268902, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381174, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246469, 52),
      ))
    }

@delegate:ResourceContentHash(-885_287_743)
public val Res.string.sales_import_column_date: StringResource by lazy {
      StringResource("string:sales_import_column_date", "sales_import_column_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 268951, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381239, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246522, 48),
      ))
    }

@delegate:ResourceContentHash(-198_719_407)
public val Res.string.sales_import_column_gross: StringResource by lazy {
      StringResource("string:sales_import_column_gross", "sales_import_column_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269000, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381292, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246571, 49),
      ))
    }

@delegate:ResourceContentHash(-785_713_494)
public val Res.string.sales_import_column_net: StringResource by lazy {
      StringResource("string:sales_import_column_net", "sales_import_column_net", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269050, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381350, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246621, 51),
      ))
    }

@delegate:ResourceContentHash(707_445_431)
public val Res.string.sales_import_column_none: StringResource by lazy {
      StringResource("string:sales_import_column_none", "sales_import_column_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269110, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381426, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246673, 52),
      ))
    }

@delegate:ResourceContentHash(-244_822_171)
public val Res.string.sales_import_column_position: StringResource by lazy {
      StringResource("string:sales_import_column_position", "sales_import_column_position", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269159, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381491, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246726, 52),
      ))
    }

@delegate:ResourceContentHash(902_342_259)
public val Res.string.sales_import_count_closed: StringResource by lazy {
      StringResource("string:sales_import_count_closed", "sales_import_count_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269212, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381556, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246779, 57),
      ))
    }

@delegate:ResourceContentHash(1_012_791_080)
public val Res.string.sales_import_count_import: StringResource by lazy {
      StringResource("string:sales_import_count_import", "sales_import_count_import", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269282, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381642, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246837, 53),
      ))
    }

@delegate:ResourceContentHash(-1_898_812_816)
public val Res.string.sales_import_count_manual: StringResource by lazy {
      StringResource("string:sales_import_count_manual", "sales_import_count_manual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269336, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381716, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246891, 61),
      ))
    }

@delegate:ResourceContentHash(416_466_362)
public val Res.string.sales_import_count_unchanged: StringResource by lazy {
      StringResource("string:sales_import_count_unchanged", "sales_import_count_unchanged", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269410, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381810, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246953, 60),
      ))
    }

@delegate:ResourceContentHash(401_150_891)
public val Res.string.sales_import_drop: StringResource by lazy {
      StringResource("string:sales_import_drop", "sales_import_drop", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269467, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 381883, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247014, 77),
      ))
    }

@delegate:ResourceContentHash(209_703_352)
public val Res.string.sales_import_file_empty: StringResource by lazy {
      StringResource("string:sales_import_file_empty", "sales_import_file_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269561, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 382009, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247092, 55),
      ))
    }

@delegate:ResourceContentHash(146_857_213)
public val Res.string.sales_import_file_hint: StringResource by lazy {
      StringResource("string:sales_import_file_hint", "sales_import_file_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 269617, 382),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 382077, 610),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247148, 374),
      ))
    }

@delegate:ResourceContentHash(-1_757_980_786)
public val Res.string.sales_import_file_no_sales: StringResource by lazy {
      StringResource("string:sales_import_file_no_sales", "sales_import_file_no_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270000, 138),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 382688, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247523, 134),
      ))
    }

@delegate:ResourceContentHash(-526_133_993)
public val Res.string.sales_import_file_title: StringResource by lazy {
      StringResource("string:sales_import_file_title", "sales_import_file_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270139, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 382903, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247658, 67),
      ))
    }

@delegate:ResourceContentHash(922_808_896)
public val Res.string.sales_import_file_too_large: StringResource by lazy {
      StringResource("string:sales_import_file_too_large", "sales_import_file_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270203, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 382983, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247726, 107),
      ))
    }

@delegate:ResourceContentHash(741_767_915)
public val Res.string.sales_import_file_unreadable: StringResource by lazy {
      StringResource("string:sales_import_file_unreadable", "sales_import_file_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270311, 156),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 383131, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247834, 136),
      ))
    }

@delegate:ResourceContentHash(333_195_066)
public val Res.string.sales_import_intro: StringResource by lazy {
      StringResource("string:sales_import_intro", "sales_import_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270468, 262),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 383372, 450),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247971, 250),
      ))
    }

@delegate:ResourceContentHash(-987_559_508)
public val Res.string.sales_import_issue_row: StringResource by lazy {
      StringResource("string:sales_import_issue_row", "sales_import_issue_row", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270731, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 383823, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248222, 58),
      ))
    }

@delegate:ResourceContentHash(292_846_506)
public val Res.string.sales_import_issues: StringResource by lazy {
      StringResource("string:sales_import_issues", "sales_import_issues", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270851, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 383947, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248338, 51),
      ))
    }

@delegate:ResourceContentHash(-1_869_653_717)
public val Res.string.sales_import_issues_more: StringResource by lazy {
      StringResource("string:sales_import_issues_more", "sales_import_issues_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270794, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 383894, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248281, 56),
      ))
    }

@delegate:ResourceContentHash(-2_118_379_873)
public val Res.string.sales_import_month_only: StringResource by lazy {
      StringResource("string:sales_import_month_only", "sales_import_month_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270911, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384023, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248390, 59),
      ))
    }

@delegate:ResourceContentHash(-2_002_290_557)
public val Res.string.sales_import_nothing: StringResource by lazy {
      StringResource("string:sales_import_nothing", "sales_import_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 270979, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384115, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248450, 96),
      ))
    }

@delegate:ResourceContentHash(-1_826_455_393)
public val Res.string.sales_import_problem_date: StringResource by lazy {
      StringResource("string:sales_import_problem_date", "sales_import_problem_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271112, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384308, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248547, 49),
      ))
    }

@delegate:ResourceContentHash(211_541_477)
public val Res.string.sales_import_problem_gross: StringResource by lazy {
      StringResource("string:sales_import_problem_gross", "sales_import_problem_gross", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271170, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384366, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248597, 78),
      ))
    }

@delegate:ResourceContentHash(-1_466_995_255)
public val Res.string.sales_import_problem_negative: StringResource by lazy {
      StringResource("string:sales_import_problem_negative", "sales_import_problem_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271245, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384457, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248676, 61),
      ))
    }

@delegate:ResourceContentHash(-590_637_151)
public val Res.string.sales_import_problem_net: StringResource by lazy {
      StringResource("string:sales_import_problem_net", "sales_import_problem_net", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271299, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384531, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248738, 72),
      ))
    }

@delegate:ResourceContentHash(61_630_824)
public val Res.string.sales_import_read_only: StringResource by lazy {
      StringResource("string:sales_import_read_only", "sales_import_read_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271372, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384620, 206),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248811, 122),
      ))
    }

@delegate:ResourceContentHash(1_449_863_336)
public val Res.string.sales_import_reading: StringResource by lazy {
      StringResource("string:sales_import_reading", "sales_import_reading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271487, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384827, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248934, 56),
      ))
    }

@delegate:ResourceContentHash(775_297_651)
public val Res.string.sales_import_title: StringResource by lazy {
      StringResource("string:sales_import_title", "sales_import_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271544, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384892, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248991, 42),
      ))
    }

@delegate:ResourceContentHash(-46_867_413)
public val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272193, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385829, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249592, 20),
      ))
    }

@delegate:ResourceContentHash(-151_583_239)
public val Res.string.saves_failed: StringResource by lazy {
      StringResource("string:saves_failed", "saves_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271595, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 384959, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249034, 52),
      ))
    }

@delegate:ResourceContentHash(1_327_991_674)
public val Res.string.saves_in_progress: StringResource by lazy {
      StringResource("string:saves_in_progress", "saves_in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271648, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385036, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249087, 85),
      ))
    }

@delegate:ResourceContentHash(-1_060_948_529)
public val Res.string.saves_kept_on_device: StringResource by lazy {
      StringResource("string:saves_kept_on_device", "saves_kept_on_device", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271730, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385142, 208),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249173, 108),
      ))
    }

@delegate:ResourceContentHash(-1_232_970_462)
public val Res.string.saves_recalculating: StringResource by lazy {
      StringResource("string:saves_recalculating", "saves_recalculating", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271863, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385351, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249282, 59),
      ))
    }

@delegate:ResourceContentHash(-2_139_566_291)
public val Res.string.saves_recalculation_failed: StringResource by lazy {
      StringResource("string:saves_recalculation_failed", "saves_recalculation_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271923, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385431, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249342, 74),
      ))
    }

@delegate:ResourceContentHash(-833_906_198)
public val Res.string.saves_retry: StringResource by lazy {
      StringResource("string:saves_retry", "saves_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 271998, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385534, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249417, 27),
      ))
    }

@delegate:ResourceContentHash(1_527_820_817)
public val Res.string.saves_saving: StringResource by lazy {
      StringResource("string:saves_saving", "saves_saving", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272152, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385776, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249559, 32),
      ))
    }

@delegate:ResourceContentHash(637_727_771)
public val Res.string.saves_saving_hint: StringResource by lazy {
      StringResource("string:saves_saving_hint", "saves_saving_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272026, 125),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385578, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249445, 113),
      ))
    }

@delegate:ResourceContentHash(-528_169_567)
public val Res.string.schedule_actual_hours: StringResource by lazy {
      StringResource("string:schedule_actual_hours", "schedule_actual_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272214, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385866, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249613, 45),
      ))
    }

@delegate:ResourceContentHash(-1_720_096_044)
public val Res.string.schedule_cant_work: StringResource by lazy {
      StringResource("string:schedule_cant_work", "schedule_cant_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272268, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 385936, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249659, 62),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString33Resources(map: MutableMap<String, StringResource>) {
  map.put("roster_role", Res.string.roster_role)
  map.put("roster_role_optional", Res.string.roster_role_optional)
  map.put("roster_save_as_template", Res.string.roster_save_as_template)
  map.put("roster_save_template", Res.string.roster_save_template)
  map.put("roster_selected_count", Res.string.roster_selected_count)
  map.put("roster_selection_apply", Res.string.roster_selection_apply)
  map.put("roster_selection_clear", Res.string.roster_selection_clear)
  map.put("roster_selection_no_templates", Res.string.roster_selection_no_templates)
  map.put("roster_shift_cost", Res.string.roster_shift_cost)
  map.put("roster_shift_deleted", Res.string.roster_shift_deleted)
  map.put("roster_shift_details", Res.string.roster_shift_details)
  map.put("roster_shift_labour_warning", Res.string.roster_shift_labour_warning)
  map.put("roster_shift_no_rate", Res.string.roster_shift_no_rate)
  map.put("roster_shift_restored", Res.string.roster_shift_restored)
  map.put("roster_shift_unsupervised", Res.string.roster_shift_unsupervised)
  map.put("roster_skeleton_empty_templates", Res.string.roster_skeleton_empty_templates)
  map.put("roster_skeleton_failed", Res.string.roster_skeleton_failed)
  map.put("roster_skeleton_no_week", Res.string.roster_skeleton_no_week)
  map.put("roster_skeleton_open", Res.string.roster_skeleton_open)
  map.put("roster_skeleton_open_finish", Res.string.roster_skeleton_open_finish)
  map.put("roster_skeleton_prompt_missing_days", Res.string.roster_skeleton_prompt_missing_days)
  map.put("roster_skeleton_prompt_no_week", Res.string.roster_skeleton_prompt_no_week)
  map.put("roster_skeleton_prompt_not_now", Res.string.roster_skeleton_prompt_not_now)
  map.put("roster_skeleton_prompt_set_up", Res.string.roster_skeleton_prompt_set_up)
  map.put("roster_skeleton_prompt_title", Res.string.roster_skeleton_prompt_title)
  map.put("roster_skeleton_title", Res.string.roster_skeleton_title)
  map.put("roster_skills", Res.string.roster_skills)
  map.put("roster_skills_list", Res.string.roster_skills_list)
  map.put("roster_start_time", Res.string.roster_start_time)
  map.put("roster_status_archived", Res.string.roster_status_archived)
  map.put("roster_status_draft", Res.string.roster_status_draft)
  map.put("roster_status_locked", Res.string.roster_status_locked)
  map.put("roster_status_published", Res.string.roster_status_published)
  map.put("roster_status_skeleton", Res.string.roster_status_skeleton)
  map.put("roster_status_skeleton_hint", Res.string.roster_status_skeleton_hint)
  map.put("roster_summary_filled", Res.string.roster_summary_filled)
  map.put("roster_summary_open", Res.string.roster_summary_open)
  map.put("roster_summary_total_hours", Res.string.roster_summary_total_hours)
  map.put("roster_time_invalid", Res.string.roster_time_invalid)
  map.put("roster_to", Res.string.roster_to)
  map.put("roster_total_hours", Res.string.roster_total_hours)
  map.put("roster_unassign", Res.string.roster_unassign)
  map.put("roster_unassigned", Res.string.roster_unassigned)
  map.put("roster_unassigned_shifts", Res.string.roster_unassigned_shifts)
  map.put("roster_unfilled", Res.string.roster_unfilled)
  map.put("roster_unfilled_short", Res.string.roster_unfilled_short)
  map.put("roster_unpublished_badge", Res.string.roster_unpublished_badge)
  map.put("roster_unpublished_hide", Res.string.roster_unpublished_hide)
  map.put("roster_unpublished_removed", Res.string.roster_unpublished_removed)
  map.put("roster_unpublished_shift", Res.string.roster_unpublished_shift)
  map.put("roster_unpublished_show", Res.string.roster_unpublished_show)
  map.put("roster_unpublished_title", Res.string.roster_unpublished_title)
  map.put("sales_import_action_closed", Res.string.sales_import_action_closed)
  map.put("sales_import_action_import", Res.string.sales_import_action_import)
  map.put("sales_import_action_manual", Res.string.sales_import_action_manual)
  map.put("sales_import_action_replace", Res.string.sales_import_action_replace)
  map.put("sales_import_action_unchanged", Res.string.sales_import_action_unchanged)
  map.put("sales_import_applied", Res.string.sales_import_applied)
  map.put("sales_import_apply", Res.string.sales_import_apply)
  map.put("sales_import_choose_file", Res.string.sales_import_choose_file)
  map.put("sales_import_column_date", Res.string.sales_import_column_date)
  map.put("sales_import_column_gross", Res.string.sales_import_column_gross)
  map.put("sales_import_column_net", Res.string.sales_import_column_net)
  map.put("sales_import_column_none", Res.string.sales_import_column_none)
  map.put("sales_import_column_position", Res.string.sales_import_column_position)
  map.put("sales_import_count_closed", Res.string.sales_import_count_closed)
  map.put("sales_import_count_import", Res.string.sales_import_count_import)
  map.put("sales_import_count_manual", Res.string.sales_import_count_manual)
  map.put("sales_import_count_unchanged", Res.string.sales_import_count_unchanged)
  map.put("sales_import_drop", Res.string.sales_import_drop)
  map.put("sales_import_file_empty", Res.string.sales_import_file_empty)
  map.put("sales_import_file_hint", Res.string.sales_import_file_hint)
  map.put("sales_import_file_no_sales", Res.string.sales_import_file_no_sales)
  map.put("sales_import_file_title", Res.string.sales_import_file_title)
  map.put("sales_import_file_too_large", Res.string.sales_import_file_too_large)
  map.put("sales_import_file_unreadable", Res.string.sales_import_file_unreadable)
  map.put("sales_import_intro", Res.string.sales_import_intro)
  map.put("sales_import_issue_row", Res.string.sales_import_issue_row)
  map.put("sales_import_issues", Res.string.sales_import_issues)
  map.put("sales_import_issues_more", Res.string.sales_import_issues_more)
  map.put("sales_import_month_only", Res.string.sales_import_month_only)
  map.put("sales_import_nothing", Res.string.sales_import_nothing)
  map.put("sales_import_problem_date", Res.string.sales_import_problem_date)
  map.put("sales_import_problem_gross", Res.string.sales_import_problem_gross)
  map.put("sales_import_problem_negative", Res.string.sales_import_problem_negative)
  map.put("sales_import_problem_net", Res.string.sales_import_problem_net)
  map.put("sales_import_read_only", Res.string.sales_import_read_only)
  map.put("sales_import_reading", Res.string.sales_import_reading)
  map.put("sales_import_title", Res.string.sales_import_title)
  map.put("save", Res.string.save)
  map.put("saves_failed", Res.string.saves_failed)
  map.put("saves_in_progress", Res.string.saves_in_progress)
  map.put("saves_kept_on_device", Res.string.saves_kept_on_device)
  map.put("saves_recalculating", Res.string.saves_recalculating)
  map.put("saves_recalculation_failed", Res.string.saves_recalculation_failed)
  map.put("saves_retry", Res.string.saves_retry)
  map.put("saves_saving", Res.string.saves_saving)
  map.put("saves_saving_hint", Res.string.saves_saving_hint)
  map.put("schedule_actual_hours", Res.string.schedule_actual_hours)
  map.put("schedule_cant_work", Res.string.schedule_cant_work)
}
